import type { QuestionType } from '../registration-form/custom-form-factory-types';

export type TicketType = {
  name: string;
  description?: string;
  price: number;
  type: string;
  salesStartTime: Nullable<string>;
  salesEndTime: Nullable<string>;
  registrationsLimit: Nullable<number>;
  status: string;
  waitlistCount: number;
  refundsEnabled: boolean;
  eventTrackId: number;
  externalId: string;
  currentRegistrations: number;
  currentWaitlistCount: number;
  questions?: Array<QuestionType>;
  accessType: 'virtual' | 'hybrid' | 'onsite';
};

export type SeriesTicketType = {
  accessType: 'virtual' | 'hybrid' | 'onsite';
  claimed: number;
  code: string;
  count: number;
  description: string;
  eventId: number;
  externalId: string;
  id: number;
  label: string;
  price: number;
  priority: number;
  privateTicket: boolean;
  refundsEnabled: boolean;
  remaining: number;
  salesActive: boolean;
  salesEndTime: Nullable<string>;
  salesStartTime: Nullable<string>;
  status: string;
  type: string;
  waitlistCount: number;
};

type TicketTypesType = {
  id: string | number;
  label: string;
};

export type CustomFormType = {
  id: string | number;
  title: string;
  eventTrack: {
    id: string | number;
    name: string;
  };
  questions: Array<QuestionType>;
  ticketTypes: Array<TicketTypesType>; //TODO(HL-1538) ticketTypes might not be used anything; remove
};

interface Settings {
  allowedFeatures: {
    [key: string]: boolean;
  };
  authEnabled: boolean;
  maxRegistrations: number | null;
  maxTicketsPerOrder: number;
  registrationCloseMessage: string;
  feeSplit: string;
  maxWaitlist: Nullable<number>;
  waitlistEnabled: Nullable<boolean>;
  successfulWaitlistMessage: string;
  unsuccessfulWaitlistMessage: string;
  registrationCloseTime: string;
  waitlistCloseTime: Nullable<string>;
  organizationId: number | null;
  organizationExternalId: Nullable<string>;
  questionBankEnabled?: boolean;
  orderConfirmationEmailEnabled?: boolean;
  confirmationCustomTitle?: string;
  confirmationCustomMessage?: string;
}

type Images = {
  medium: string;
  large: string;
};

type Event = {
  name: string;
  externalId: string;
  url: string;
  startTime: string;
  endTime: string;
  totalUsersRegistered: number;
  totalUsersWaitlisted: number;
  currency: string;
  organizationMerchantId: Nullable<string>;
  doorsOpenTime: string;
  doorsCloseTime: string;
  postEventEnabled: boolean;
  postEventTimeEnd: Nullable<string>;
  fullUrl: string;
  linkedinCompanyUrlEnabled: boolean;
  linkedinCompanyUrl: string;
  linkedinEventId: string;
  linkedinCommunityBuilderEnabled: boolean;
  eventType: EventType;
  isLite: boolean;
  published: boolean;
};

export enum EventType {
  Public = 'public_event',
  Private = 'private_event',
  Hidden = 'hidden_event',
}

export interface State {
  event: Event;
  images: Images;
  settings: Settings;
  tickets: Array<TicketType>;
  forms: Array<CustomFormType>;
  stripeDirect: boolean;
  googleAnalyticsCode: Nullable<string>;
  widgetId: Nullable<string>;
  widgetSource: string;
  single_ticket_without_segments: boolean;
  isExternalWidget: boolean;
  trackingIntegrations: Array<TrackingIntegration>;
  showEventSeries: boolean;
}

export interface TrackingIntegration {
  id: Nullable<string>;
  attributes: { code: Nullable<string> };
}

export interface EventDetailsResponse
  extends Omit<State, 'isExternalWidget' | 'showEventSeries'> {
  settings: Omit<Settings, 'organizationId'> & {
    organizationId: number;
  };
}

export type SeriesEventWidget = {
  event: Event;
  images: Images;
  settings: Settings;
};
